import React, { useState, useEffect } from 'react';
import api from '../services/api';

const Prizes = () => {
    const [mainLeaderboard, setMainLeaderboard] = useState([]);
    const [calcuttaLeaderboard, setCalcuttaLeaderboard] = useState([]);
    const [calcuttaWinnersCount, setCalcuttaWinnersCount] = useState(3);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const mainResponse = await api.get('/leaderboard/main');
                setMainLeaderboard(mainResponse.data);

                const calcuttaResponse = await api.get('/leaderboard/calcutta');
                setCalcuttaLeaderboard(calcuttaResponse.data);

                const settingsResponse = await api.get('/settings');
                const calcuttaSetting = settingsResponse.data.find(s => s.name === 'calcutta_winners');
                if (calcuttaSetting) {
                    setCalcuttaWinnersCount(parseInt(calcuttaSetting.value, 10));
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const mainWinners = mainLeaderboard.slice(0, 3);
    const calcuttaWinners = calcuttaLeaderboard.slice(0, calcuttaWinnersCount);

    return (
        <div className="setup-main">
            <section className="setup-section">
                <h2>Prize Winners</h2>
                <div className="winners-container">
                    <div className="event-column">
                        <h3>Regular Event</h3>
                        {mainWinners.map((winner, index) => (
                            <div key={winner.license_number} className="winner">
                                <strong>{index + 1}{index === 0 ? 'st' : index === 1 ? 'nd' : 'rd'} Place:</strong> {winner.name} {winner.business && `(${winner.business})`} - {winner.total_Pounds} lbs {winner.total_OuncesRemainder} oz
                            </div>
                        ))}
                    </div>
                    {calcuttaWinnersCount > 0 && (
                        <div className="event-column">
                            <h3>Calcutta Event</h3>
                            {calcuttaWinners.map((winner, index) => (
                                <div key={winner.license_number} className="winner">
                                    <strong>{index + 1}{index === 0 ? 'st' : index === 1 ? 'nd' : 'rd'} Place:</strong> {winner.name} {winner.business && `(${winner.business})`} - {winner.total_Pounds} lbs {winner.total_OuncesRemainder} oz
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Prizes;